/**
 * PEOPLE PAGE - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Dark tool mode.
 */

import React, { useState } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Screen, Section, Button } from '../design/primitives';
import PeopleList from '../components/PeopleList';
import PersonForm from '../components/forms/PersonForm';

const PeoplePage: React.FC = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return (
    <Screen>
      <Section
        title="People"
        action={
          <Button
            variant="primary"
            onClick={() => setIsAddModalOpen(true)}
            icon={<PlusIcon style={{ width: '16px', height: '16px' }} />}
          >
            Add Person
          </Button>
        }
      >
        <PeopleList />
      </Section>

      <PersonForm
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onPersonCreated={() => {
          setIsAddModalOpen(false);
        }}
      />
    </Screen>
  );
};

export default PeoplePage;
